import React, { useState, useEffect } from 'react'
import Player from '../player';
import Map from '../map'
import API from "../../utils/API";
import { useHistory, useParams } from "react-router-dom";
import { ForestThiefMoved } from '../../data/maps/1'
import store from '../../config/store'
import MusicBtn from '../../components/SoundBtns/MusicBtn';
import { resolveStageEntrySpawn, prepareConnectedTransition } from "../../config/worldTransitions";

//creates a game map for the forest map after the thief moves
function ForestWorldTheifMoved(props) {
    let tiles = ForestThiefMoved;
   
    const { id } = useParams();
    const history = useHistory();
    store.dispatch({
        type: 'ADD_TILES', payload: {
            tiles,
        }
    });
    const [userAvatar, setUserAvatar] = useState(null)
    useEffect(() => {
        API.UpdateSpritePlace("forest", id).then(()=> {
        })
        // API.getUserSprite(id).then(user => {
        //     const { sprite } = user.data[0].sprite[0]
        //     return setUserAvatar(sprite)
        // })
    }, []);


    // Preserve a connected entrance through avatar/API-driven rerenders.
    const [initialPosition] = useState(() => resolveStageEntrySpawn(id, "forest", props.initialPosition));

    return (
        <div
            id="world-container"
            style={{
                position: 'relative',
                width: '968px',
                top: '35%',
                // marginTop: '50px',
                marginLeft: '3px',
                border: '4px solid black',
                borderRadius: '5px'
            }}
        >
            <MusicBtn />
            <Map />
            <Player
                avatar={props.avatar}
                avatarName={props.avatarName}
                onRightEdge={(position) => {
                    const cell = [position[0] / 64, position[1] / 64];
                    const direction = cell[0] === 0 ? "WEST" : (cell[1] === 14 ? "SOUTH" : "EAST");
                    const transition = prepareConnectedTransition(id, "forest", direction, cell);
                    if (!transition) return;
                    const destinationPath = transition.destination === "cliff" ? "cliffs" : transition.destination;
                    API.UpdateSpritePlace(transition.destination, id).catch(() => {});
                    history.push(`/${destinationPath}/` + id);
                }}
                exitZones={{ WEST: [[0, 7]], EAST: [[14, 8]], SOUTH: [[6, 14]] }}
                initialPosition={initialPosition}
            />
        </div>
    )
}

export default ForestWorldTheifMoved;